import { CurdDataSetConfig, FormFieldType } from '../types';
import { toDateFormat } from '@mri/functions';
import { SimCard } from '@mri/types';
import { ChoiceTypes } from '@mri/enums';
import { propertyCommonField } from './property-common-field';

export const simCardDataSetConfig: CurdDataSetConfig<SimCard> = {
  entityName: 'Simcard',
  collectionName: 'Sim Cards',
  gatewayUrl: 'sim-cards',
  baseBreadcrumb: 'sim-cards',
  form: {
    listRedirectUrl: 'console/sim-cards/list',
    fields: [
      {
        key: 'phoneLine',
        label: 'Linea Telefonica',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6'
      },
      {
        key: 'operator',
        label: 'Operador',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.OPERATOR
      },
      {
        key: 'cardUniqueId',
        label: 'Identificador de la tarjeta',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
      },
      propertyCommonField
    ]
  },
  list: {
    pageConfig: {
      title: 'Lista de simcares',
      breadcrumb: [
        {
          title: 'Simcares',
          type: 'item',
          link: 'console/simcards/list',
        },
        {
          title: 'Lista',
          type: 'item',
          pageName: 'Simcares'
        }
      ]
    },
    filter: [
      {
        key: 'phoneLine',
        label: 'Linea Telefonica',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6'
      },
      {
        key: 'operator',
        label: 'Operador',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.OPERATOR
      },
      {
        key: 'cardUniqueId',
        label: 'Identificador de la tarjeta',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
      },
      propertyCommonField
    ],
    table: {
      columns: [
        { key: 'phoneLine', label: 'Linea Telefonica' },
        {
          key: 'operator', label: 'Operador',
          getValue: ({ element }) => element?.operatorData?.label['default'] || 'No definido',
        },
        {
          key: 'device', label: 'Dispositivo',
          getValue:  ({ element }) => element?.device?.name || 'No definido',
        },
        {
          key: 'owner', label: 'Dueño',
          getValue:  ({ element }) => element?.property?.name || 'No definido'
        },

        {
          key: 'createdTime', label: 'Fecha de creación',
          getValue:  ({ element }) => toDateFormat(element.createdTime)
        }
      ]
    },
    actionsKeys: ['create', 'edit', 'transfer', 'delete']
  },
  pages: ['list', 'create', 'edit']
};
